/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resting between sets in a HIIT or circuit workout.`)
};

const es_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar entre series en un entrenamiento HIIT o de circuito.`)
};

const de_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischen Sätzen bei einem HIIT- oder Zirkeltraining pausieren.`)
};

const nl_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rusten tussen sets in een HIIT- of circuittraining.`)
};

const fr_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se reposer entre les séries d’un entraînement HIIT ou en circuit.`)
};

const it_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riposare tra le serie in un allenamento HIIT o a circuito.`)
};

const pt_br2_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar entre séries em um treino HIIT ou em circuito.`)
};

const pt_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar entre séries num treino de HIIT ou circuito.`)
};

const ja_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HIITやサーキットトレーニングのセット間で休憩を取る。`)
};

const zh_timer_u5m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在高强度间歇训练或循环训练的组间休息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_use1", locale)
	if (locale === "en") return en_timer_u5m_use1(inputs)
	if (locale === "es") return es_timer_u5m_use1(inputs)
	if (locale === "de") return de_timer_u5m_use1(inputs)
	if (locale === "nl") return nl_timer_u5m_use1(inputs)
	if (locale === "fr") return fr_timer_u5m_use1(inputs)
	if (locale === "it") return it_timer_u5m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_use1(inputs)
	if (locale === "pt") return pt_timer_u5m_use1(inputs)
	if (locale === "ja") return ja_timer_u5m_use1(inputs)
	return zh_timer_u5m_use1(inputs)
};